import React from "react";
import "./footer.css";
import Logo from "../../components/images/Mihailo.svg";

function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-col footer-brand">
            <img src={Logo} alt="Mihailo Fitness Logo" />
            <p className="footer-brand-desc">
              Personalizovani treninzi, online coaching i planovi ishrane — za
              svaki nivo, svaki uzrast, svaki cilj.
            </p>
            <a
              className="footer-instagram"
              href="https://www.instagram.com/mihailo.trener.zivanovic/"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
          </div>

          <div className="footer-col">
            <span className="footer-heading">Navigacija</span>
            <ul className="footer-list">
              <li>
                <a href="/">Početna</a>
              </li>
              <li>
                <a href="/biografija/">Biografija</a>
              </li>
              <li>
                <a href="/trening-uzivo/">Uživo trening</a>
              </li>
              <li>
                <a href="/online-trening/">Online trening</a>
              </li>
              <li>
                <a href="/plan-ishrane/">Plan ishrane</a>
              </li>
              <li>
                <a href="/transformacije/">Transformacije</a>
              </li>
              <li>
                <a href="/kontakt/">Kontakt</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <span className="footer-heading">Usluge</span>
            <ul className="footer-list">
              <li>
                <a href="/trening-uzivo/">Uživo trening</a>
              </li>
              <li>
                <a href="/online-trening/">Online trening</a>
              </li>
              <li>
                <a href="/plan-ishrane/">Plan ishrane</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <span className="footer-heading">Kontakt</span>
            <div className="footer-contact">
              <span className="footer-contact-label">Email</span>
              <a href="mailto:info@mihailo-fitness.rs">
                info@mihailo-fitness.rs
              </a>
              <span className="footer-contact-label">Telefon</span>
              <a href="tel:+381600737363">+381 60 073 7363</a>
              <span className="footer-contact-label">Lokacija</span>
              <span className="footer-contact-text">Beograd, Srbija</span>
            </div>
          </div>
        </div>
      </footer>

      <div className="copyright">
        &copy; {new Date().getFullYear()} Mihailo Živanović. Sva prava zadržana.
        | by&nbsp;
        <a
          className="copyright-link"
          href="https://scaons.com/"
          target="_blank"
          rel="noreferrer"
        >
          SCAONS
        </a>
      </div>
    </>
  );
}

export default Footer;
